export const environment = {
  production: false,
  apiUrl: 'https://api-stg.riskyid.com',
  baseUrl: 'https://rbo-stg.riskyid.com/login',
  version: '1.0.0-stg',
  name: 'staging',
  debug: true,
  logLevel: 'debug',
  enableAnalytics: false,
  backofficeAuditEmail: 'ridbackoffice@myservy.com',
  firebase: {
    apiKey: "AIzaSyAJ1llwwcsetCCVQYr6fw0N_xvCQJcf8Ug",
    authDomain: "riskyidstaging.firebaseapp.com",
    projectId: "riskyidstaging",
    storageBucket: "riskyidstaging.firebasestorage.app",
    messagingSenderId: "845604583660",
    appId: "1:845604583660:web:b9415398a65c7255468dc9"
  },
};
